import axios from "axios";
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import {
  get_tokens_url,
  token_apim_subscription_key,
  apim_subscription_key,
} from "./API";

// Basic clientId:clientSecret for the client_credentials grant against
// /security/v1/token, per env. Prod value is the long-standing shipped
// credential. Dev value confirmed 2026-07-24 (minted a valid SystemAdmin
// service token against api.clubreadydev.com). Staging deliberately reuses
// dev's value as a testing expedient so stage QA is not blocked — the same
// client-credential account exists in stage's Security DB (probed 2026-07-24:
// crstage-apim /security/v1/token returned 200). Replace it once a
// stage-specific client-credential account is sourced.
const clientBasicByEnv: Record<string, string> = {
  development: "YWRtaW5AQ2x1YlJlYWR5LmNvbToyOU8haUZZRHZ6anlBZDYhUkEkM2VjRVc=",
  staging: "YWRtaW5AQ2x1YlJlYWR5LmNvbToyOU8haUZZRHZ6anlBZDYhUkEkM2VjRVc=",
  production:
    "OWEyNDE5NTQtM2NkMy00NmU4LWJhMDYtMmM4MTViY2VkNTk1OjAxNjdjM2VjLWE2ZmYtNGQxMS1iNjY0LTk4M2EwZDUzM2VlNA==",
};

const resolvedEnv = process.env.REACT_APP_ENV as string;

export const client_basic: string =
  clientBasicByEnv[resolvedEnv] ?? clientBasicByEnv.production;
//AWS Credentials
var poolData = {
  UserPoolId: "us-west-2_fdYTmcUkO",
  ClientId: "5sc6p64s3mvq5i4ah0srs1d8np",
};
var userPool = new CognitoUserPool(poolData);
var cognitoUser: any = null;
var piq_admin_user: any = {
  username: "piq-admin-user",
  password: "d76f7s6jej*9!",
};

var headers: any;

export async function loginAWS() {
  return await login(piq_admin_user.username, piq_admin_user.password);
}

export async function getAWSHeader() {
  return String(getToken());
}

async function login(username: string, password: string) {
  return new Promise((resolve, reject) => {
    const authenticationData = {
      Username: username,
      Password: password,
    };

    const authenticationDetails = new AuthenticationDetails(authenticationData);

    if (cognitoUser == null) {
      //The user was not signed up...Creating User
      const userData = {
        Username: username,
        Pool: userPool,
      };

      cognitoUser = new CognitoUser(userData);
    }

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result: any) {
        this.logged_in = true;
        resolve(true);
      },
      onFailure: function (err: any) {
        console.log(
          "There was an error trying to authenticate this user!",
          err
        );
        reject(false);
      },
    });
  });
}

export function getToken() {
  let token = null;
  const authenticatedUser = getAuthenticatedUser();

  if (authenticatedUser == null) return;

  authenticatedUser.getSession((err: any, session: any) => {
    if (err) {
      console.log("Error getting session!");
      return err;
    }

    token = session.getIdToken().getJwtToken();
  });

  return token;
}

export function getAuthenticatedUser() {
  return userPool.getCurrentUser();
}

export const format_url = (url: string, field_values: any) => {
  for (let field_value in field_values) {
    url = url.replace(
      `{${field_values[field_value]["key"]}}`,
      field_values[field_value]["value"]
    );
  }

  return url;
};

export const get_token = async () => {
  const headers = {
    "Ocp-Apim-Subscription-Key": token_apim_subscription_key,
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Basic ${client_basic}`,
  };
  return await axios
    .post(
      `${get_tokens_url}`,
      { grant_type: "client_credentials" },
      { headers }
    )
    .then((results) => results.data.access_token);
};

export const construct_headers = (type: string, token: string = "") => {
  getAWSHeader().then((data) => {
    headers = {
      Authorization: data,
      Accept: "application/json",
    };
  });
  if (type == "piq_api") {
    return headers;
  } else {
    switch (type) {
      case "mobile": // Mobile Services ClubReady API
        return {
          Authorization:
            "Basic bW9iaWxlLWxvZ2luOjA3NDgyNzhGN0Q1RTREQjc4NDIzOTM0NDUwMEE0QjZF",
          Accept: "application/json",
        };
      case "new": // new ClubReady API
        return {
          "Ocp-Apim-Subscription-Key": apim_subscription_key,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
      case "piq_widget": // PIQ New (Public) API
        return {
          Accept: "application/json",
        };
      default: // old ClubReady API
        return {
          Accept: "application/json",
        };
    }
  }
};